import HttpHelper from '@/helpers/http';
import { ITransition } from '@/helpers/transition';

export interface ITransitionResponse {
  success: boolean;
  transitions: ITransition[];
}

export default class TransitionApi {
  static async getTransitions(): Promise<ITransitionResponse> {
    return await HttpHelper.get('/api/v1/transitions');
  }
}
